export const joinButtonClasses = (...classes) => classes.filter(Boolean).join(' ');

export const dsButtonBase =
  'inline-flex items-center justify-center gap-2 rounded-ds-sm border text-[13px] font-semibold leading-none transition-all duration-200 ease-[cubic-bezier(.22,1,.36,1)] active:scale-[0.97] focus:outline-none focus-visible:ring-2 focus-visible:ring-ds-brand focus-visible:ring-offset-1';

export const dsButtonPrimary =
  `${dsButtonBase} border-blue-600 bg-blue-600 px-5 py-3 text-white shadow-sm hover:border-blue-800 hover:bg-blue-800`;

export const dsButtonSecondary =
  `${dsButtonBase} border-gray-250 bg-white px-5 py-3 text-gray-900 shadow-sm hover:border-gray-400 hover:bg-gray-100`;

export const dsButtonDanger =
  `${dsButtonBase} border-red-600 bg-red-600 px-5 py-3 text-white shadow-sm hover:border-red-800 hover:bg-red-800`;

export const dsButtonGhostDanger =
  `${dsButtonBase} border-red-600 bg-white px-5 py-3 text-red-600 shadow-sm hover:border-red-800 hover:bg-red-50 hover:text-red-700`;

export const dsButtonGhostBrand =
  `${dsButtonBase} border-blue-600 bg-white px-5 py-3 text-blue-600 shadow-sm hover:border-blue-800 hover:bg-blue-100 hover:text-blue-800`;

export const dsButtonLink =
  'inline-flex items-center justify-center gap-2 border-b border-transparent px-0 py-0 text-[13px] font-semibold leading-none text-blue-600 transition-all duration-200 ease-[cubic-bezier(.22,1,.36,1)] hover:text-blue-800 focus:outline-none';

export const dsButtonTextAction =
  'inline-flex items-center justify-center gap-1 border-b border-transparent px-0 py-0 text-[13px] font-semibold leading-none text-blue-600 transition-all duration-200 ease-[cubic-bezier(.22,1,.36,1)] hover:text-blue-800 focus:outline-none';

export const dsButtonDisabledPrimary = 'cursor-not-allowed border-gray-400 bg-gray-400 text-white shadow-none';
export const dsButtonDisabledSecondary = 'cursor-not-allowed border-gray-250 bg-gray-100 text-gray-400 shadow-none';
export const dsButtonDisabledLink = 'cursor-not-allowed text-gray-400';
export const dsButtonDisabledTextAction = 'cursor-not-allowed text-gray-400';

export const dsButtonSm = 'h-9 px-4 py-2';
export const dsButtonLg = 'h-11 px-6 py-3 text-[15px]';
export const dsButtonIcon = 'h-9 w-9 px-0 py-0';

export const dsButtonTertiary =
  'inline-flex items-center justify-center gap-2 rounded-ds-sm border border-transparent bg-transparent px-5 py-3 text-[13px] font-semibold leading-none text-gray-600 transition-all duration-200 ease-[cubic-bezier(.22,1,.36,1)] active:scale-[0.97] hover:bg-gray-100 hover:text-gray-900 focus:outline-none';

export const dsButtonBrand =
  `${dsButtonBase} border-ds-brand bg-ds-brand px-5 py-3 text-white shadow-sm hover:border-ds-brand-dk hover:bg-ds-brand-dk`;

export const dsButtonPill =
  `${dsButtonBase} rounded-ds-pill border-blue-600 bg-blue-600 px-5 py-3 text-white shadow-sm hover:border-blue-800 hover:bg-blue-800`;

export const dsButtonIconCircle =
  'inline-flex h-9 w-9 items-center justify-center rounded-full border border-gray-250 bg-white p-0 text-gray-700 shadow-sm transition-all duration-200 ease-[cubic-bezier(.22,1,.36,1)] hover:border-gray-400 hover:bg-gray-100 focus:outline-none';

export const dsButtonLgIcon = 'inline-flex h-11 w-11 items-center justify-center rounded-ds-sm border border-gray-250 p-0 shadow-sm focus:outline-none';

export const dsButtonSpinnerInline =
  'relative inline-flex cursor-wait items-center justify-center gap-2 opacity-85 pointer-events-none';

export const dsButtonSpinnerOverlay = 'pointer-events-none opacity-85';
